export const TERMS_VERSION = "2026-08-14";
export const REFUND_POLICY_VERSION = "2026-08-14";
export const PRIVACY_POLICY_VERSION = "2026-08-14";
export const WITHDRAWAL_NOTICE_VERSION = "2026-08-14";

export const legalVersions = {
  termsVersion: TERMS_VERSION,
  refundPolicyVersion: REFUND_POLICY_VERSION,
  privacyPolicyVersion: PRIVACY_POLICY_VERSION,
  withdrawalNoticeVersion: WITHDRAWAL_NOTICE_VERSION,
} as const;
